import { langToLocale } from '@/app/i18n/constants';
import { LOCALE_COOKIE_KEY } from '@/app/utils/constants';

export function getInitialLocale(): string {
  if (typeof window === 'undefined') return 'en-US';

  // Check cookie first
  const cookieMatch = document.cookie.match(new RegExp(`${LOCALE_COOKIE_KEY}=([^;]+)`));
  if (cookieMatch) {
    const lang = cookieMatch[1];
    return langToLocale[lang] || lang;
  }

  return 'en-US';
}

export function setLocaleCookie(locale: string) {
  // Store the short code (en, nb) in the cookie
  const shortCode = locale.split('-')[0];
  document.cookie = `${LOCALE_COOKIE_KEY}=${shortCode}; path=/; max-age=31536000; SameSite=Lax`;
}
